import {
  type AcceptInvitationRequest,
  apiPath,
  AuthSessionSchema,
  InvitationPreviewSchema,
  type LoginRequest,
  PasswordResetPreviewSchema,
  type SignupRequest,
  TwoFactorChallengeSchema,
} from '@codot/contracts';
import { z } from 'zod';
import { request } from './http';

export const authApi = {
  me: () => request('GET', apiPath('authMe'), AuthSessionSchema),
  /** A session, or (two-factor on) a challenge for the code. */
  login: (body: LoginRequest) => request('POST', apiPath('authLogin'), z.union([AuthSessionSchema, TwoFactorChallengeSchema]), body),
  login2fa: (challenge: string, code: string) => request('POST', apiPath('authLogin2fa'), AuthSessionSchema, { challenge, code }),
  signup: (body: SignupRequest) => request('POST', apiPath('authSignup'), AuthSessionSchema, body),
  logout: () => request('POST', apiPath('authLogout'), null),
  switchOrganization: (organizationId: string) =>
    request('POST', apiPath('authSwitchOrganization'), AuthSessionSchema, { organizationId }),
  previewInvitation: (token: string) =>
    request('GET', apiPath('invitationPreview', { token }), InvitationPreviewSchema),
  acceptInvitation: (body: AcceptInvitationRequest) =>
    request('POST', apiPath('invitationAccept'), AuthSessionSchema, body),
  requestPasswordReset: (email: string) => request('POST', apiPath('authPasswordReset'), null, { email }),
  previewPasswordReset: (token: string) => request('GET', apiPath('authPasswordResetToken', { token }), PasswordResetPreviewSchema),
  confirmPasswordReset: (token: string, password: string) => request('POST', apiPath('authPasswordResetConfirm'), null, { token, password }),
};
